/*
modal.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/hdx/components/hdx-bootstrap/js/hdx-bootstrap/modal',[
    'jquery'
], function ($) {
    'use strict';

    // Never try and talk to elements including the body until the page is ready.
    $(document).ready(function () {

        var isTouchDevice = 'ontouchstart' in document.documentElement;

        if (isTouchDevice) {
            // Fix issue where ipad scrolls when draggin on modal background
            $(window).on('touchmove', function (event) {
                if ($(event.target).hasClass('modal')) {
                    // no more scrolling
                    event.preventDefault();
                }
            });
        }

    });
});

